import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

/**
 * Icon-only grid action with tooltip (DataGrid cells should stay compact).
 */
export function ActionIconButton({
  title,
  onClick,
  href,
  download,
  children,
  color = "default",
}) {
  if (href) {
    return (
      <Tooltip title={title}>
        <IconButton
          size="small"
          className="cellActionIconBtn"
          component="a"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          download={download || undefined}
          color={color}
        >
          {children}
        </IconButton>
      </Tooltip>
    );
  }
  return (
    <Tooltip title={title}>
      <IconButton
        size="small"
        className="cellActionIconBtn"
        onClick={onClick}
        color={color}
      >
        {children}
      </IconButton>
    </Tooltip>
  );
}
